import { render, staticRenderFns } from "./footer-menus.vue?vue&type=template&id=0b35cc50&scoped=true&lang=pug&"
import script from "./footer-menus.vue?vue&type=script&lang=coffee&"
export * from "./footer-menus.vue?vue&type=script&lang=coffee&"
import style0 from "./footer-menus.vue?vue&type=style&index=0&id=0b35cc50&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35cc50",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
